import './Popup.scss';

export default function AddUserPopup({ onClick, text }) {
    return (
        <div className='popup_container' >
            <div className='white_block' >
                <h3>{text || 'User has been added successfully'}</h3>

                <button
                    onClick={onClick}
                >
                    Ok
                </button>


            </div>
        </div>
    )
}
